import { configProviderManager } from '../../config-provider';

export const fetchYumiwiTheOriginalsMember = async (nid: string, memberId: string): Promise<any> => {
	try {
		const headers = configProviderManager.getBffHeaders();
		const xAuthToken = 'DPcZYVsKBe2rZJlBHeOEld6mibWw1lKQtzgSWepx0b669aca';
		const url = configProviderManager.getBffUrl();
		const path = 'yumiwi/thor/member';

		const formData = new FormData();
		formData.append('nid', nid);
		formData.append('memberId', memberId);

		const response = await fetch(`${url}/${path}`, {
			method: 'POST',
			headers: {
				...(headers ? (headers as Record<string, string>) : {}),
				'X-Auth-Token': xAuthToken,
			},
			body: formData,
		});

		return await response.json();
	} catch (err) {
		return null;
	}
};

export const fetchYumiwiTheOriginalsPlateCheck = async (plate: string): Promise<any> => {
	try {
		const headers = configProviderManager.getBffHeaders();
		const xAuthToken = 'DPcZYVsKBe2rZJlBHeOEld6mibWw1lKQtzgSWepx0b669aca';
		const url = configProviderManager.getBffUrl();
		const path = 'yumiwi/thor/plate-check';

		const formData = new FormData();
		formData.append('plate', plate);

		const response = await fetch(`${url}/${path}`, {
			method: 'POST',
			headers: {
				...(headers ? (headers as Record<string, string>) : {}),
				'X-Auth-Token': xAuthToken,
			},
			body: formData,
		});

		return await response.json();
	} catch (err) {
		return null;
	}
};

export const fetchYumiwiTheOriginalsAttendee = async (formData: FormData): Promise<any> => {
	try {
		const headers = configProviderManager.getBffHeaders();
		const xAuthToken = 'DPcZYVsKBe2rZJlBHeOEld6mibWw1lKQtzgSWepx0b669aca';
		const url = configProviderManager.getBffUrl();
		const path = 'yumiwi/thor/attendees';

		const response = await fetch(`${url}/${path}`, {
			method: 'POST',
			headers: {
				...(headers ? (headers as Record<string, string>) : {}),
				'X-Auth-Token': xAuthToken,
			},
			body: formData,
		});

		return await response.json();
	} catch (err) {
		return null;
	}
};
